import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'moment/locale/pt-br';
import get from 'lodash/get';

import {
  Button,
  Form,
  Drawer,
  Modal,
  Tabs,
} from 'antd';

import { Cod } from '~/components/UI';
import * as actions from '../actions';
import Details from './Details';
import Cadences from './Cadences';
import InstagramThread from '~/_domains/socialSelling/Drawer/InstagramThread';

const ProspectingDrawer = ({
  form,
}) => {
  const dispatch = useDispatch();

  const {
    drawer,
    columns,
  } = useSelector(state => state.prospecting);
  const data = drawer.data;

  const [loading, setLoading] = useState(false);

  const handleCreate = () => {
    const { data } = drawer;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      setLoading(true);
      const { name, column_id, ...restValues } = values;
      dispatch(actions.create({
        additional_data: {
          ...get(data, 'additional_data', {}),
          ...restValues,
        },
        name: values.name,
        entity_type: 'prospecting',
        column_id: values.column_id || 1,
        board_id: 1,
      }))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  })};

  const handleSave = () => {
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      console.log('values', values);

      setLoading(true);
      const { name, column_id, ...restValues } = values;
      dispatch(actions.update(get(data, 'id'), {
        additional_data: {
          ...get(data, 'additional_data', {}),
          ...restValues,
        },
        name: values.name,
        column_id: values.column_id || 1,
      }))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    });
  }

  const handleDelete = () => {
    Modal.confirm({
      title: 'Você realmente deseja excluir este lead?',
      content: 'Esta ação não poderá ser revertida.',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => dispatch(actions.remove(data))
    });
  }

  const closeDrawerLeads = () => {
    form.resetFields();
    dispatch(actions.close());
  }

  var instagramHandle = data && (data.instagram || (data.additional_data && data.additional_data.instagram));
  var showInstagram = true;

  return (
    <Drawer
      title={get(data, 'id') ? <span>Editar Lead <Cod float="right">#CRM{get(data, 'id')}</Cod></span> : 'Cadastrar Lead'}
      width={showInstagram ? 1280 : 800}
      placement="right"
      onClose={closeDrawerLeads}
      maskClosable={false}
      visible={get(drawer, 'show', false)}
      destroyOnClose={true}
      style={{
        height: '100%',
        overflow: 'hidden',
        paddingBottom: 53,
      }}
      bodyStyle={{ padding: 0, height: '100%' }}
    >
      <div style={{ display: 'flex', height: 'calc(100vh - 55px - 53px)', gap: 0 }}>
        {/* Left: details/cadence tabs */}
        <div style={{ flex: 1, minWidth: 0, overflow: 'auto', padding: 24, borderRight: '1px solid #f0f0f0' }}>
          <Tabs defaultActiveKey="1" type='card'>
            <Tabs.TabPane tab="Detalhes" key="1">
              <Details
                data={data}
                columns={columns}
                form={form}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Cadência" key="2">
              <Cadences
                data={data}
                form={form}
              />
            </Tabs.TabPane>
          </Tabs>
        </div>

        {/* Right: Instagram thread — visible to anyone with access to this page */}
        {showInstagram && (
          <div style={{ width: 440, flexShrink: 0, background: '#fafafa', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <InstagramThread instagramHandle={instagramHandle} />
          </div>
        )}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }}
      >
        {get(data, 'id') && (<Button onClick={handleDelete} type="danger" style={{ marginRight: '8px' }}>Deletar</Button>)}
        <Button
          style={{
            marginRight: 8,
          }}
          onClick={closeDrawerLeads}
        >
          Cancelar
        </Button>
        {get(data, 'id') ? (
          <Button onClick={handleSave} type="primary" loading={loading}>Salvar</Button>
        ) : (
          <Button onClick={handleCreate} type="primary" loading={loading}>Cadastrar</Button>
        )}
      </div>
    </Drawer>
  )
}

export default Form.create()(ProspectingDrawer);